import React, {useRef, useState} from "react";
import PropTypes from 'prop-types';
import {I18n} from '../../I18n/components/Company';

const LogoUpload = props => {
    const inputFile = useRef(null);

    const onButtonClick = () => {
        inputFile.current.click();
    };

    return (
        <div>
            <input
                style={{ display: "none" }}
                accept="image/*"
                ref={inputFile}
                onChange={props.onLogoSelect}
                type="file"
            />
            <div className="companies-logo-button" onClick={onButtonClick}>
                {I18n[props.lang].choose}
            </div>
        </div>
    );
};

LogoUpload.propTypes = {
    onLogoSelect: PropTypes.func,
    lang: PropTypes.string,
};

export default LogoUpload;



// WEBPACK FOOTER //
// ./src/components/Company/LogoUpload.js